// eslint-disable-next-line
import ApiService from '../api.service';

const Posts = {
  index: params => ApiService.query('/api/v1/principals/me/posts', params),
  create: params => ApiService.post('/api/v2/principals/me/posts', params),
  delete: postId => ApiService.delete(`/api/v1/principals/me/posts/${postId}`),
  report: params => ApiService.post(`/api/v1/principals/me/posts/${params.post_id}/reports`, params),
  show: postId => ApiService.get(`/api/v1/principals/me/posts/${postId}`),
  update: params => ApiService.put(`/api/v1/principals/me/posts/${params.post_id}`, params),
};

export default Posts;
